import { createSlice } from "@reduxjs/toolkit";
import { networkStatus } from "@Src/constants";
import memberExportReducer from "./reducers/memberExportReducer";

export const initialState = {
  csvExport: {
    apiState: {
      status: networkStatus.CLEAR,
      error: null,
    },
    memberExport: {
      job_id: null,
      program_key: null,
      export_filename: null,
      status: null,
      last_status_update: null,
    },
    exportedData: null,
  },
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    //Member Export
    memberExportRequest: memberExportReducer.memberExportRequest,
    memberExportResponse: memberExportReducer.memberExportResponse,
    memberExportError: memberExportReducer.memberExportError,
    checkExportStatusRequest: memberExportReducer.checkExportStatusRequest,
    checkExportStatusResponse: memberExportReducer.checkExportStatusResponse,
    memberExportDownloadRequest: memberExportReducer.memberExportDownloadRequest,
    memberExportDownloadResponse: memberExportReducer.memberExportDownloadResponse,
  },
});

export const adminActions = adminSlice.actions;
export default adminSlice.reducer;
